import React from "react";

const HPagination = ({ currentPage = 0, totalPages = 0, onPageChange, className = "" }) => {
  // Don't render if there's only one page or no pages
  if (totalPages <= 1) return null;

  return (
    <div className={`flex gap-4 justify-center items-center p-4 mt-6 bg-white rounded-lg border ${className}`}>
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 0}
        className="px-3 py-2 rounded-md border disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
      >
        Previous
      </button>

      <div className="flex gap-2">
        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
          const pageNum =
            currentPage <= 2 ? i : currentPage >= totalPages - 3 ? totalPages - 5 + i : currentPage - 2 + i;

          if (pageNum < 0 || pageNum >= totalPages) return null;

          return (
            <button
              key={pageNum}
              onClick={() => onPageChange(pageNum)}
              className={`px-3 py-2 border rounded-md ${
                currentPage === pageNum ? "bg-blue-500 text-white border-blue-500" : "hover:bg-gray-50"
              }`}
            >
              {pageNum + 1}
            </button>
          );
        })}
      </div>

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage >= totalPages - 1}
        className="px-3 py-2 rounded-md border disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
      >
        Next
      </button>

      <span className="ml-4 text-sm text-gray-600">
        Page {currentPage + 1} of {totalPages}
      </span>
    </div>
  );
};

export default HPagination;
